// extracted by mini-css-extract-plugin
module.exports = {"box":"box--1mp68","news":"news--2MXQi","tab":"tab--1lfCR","item":"item--z89nN","active":"active--XS9or","more":"more--1eYM2","list":"list--u2kt-","first":"first--3X1Uh"};